// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Redux actions
import { change } from 'redux-form';

// Google Maps Components (Official @react-google-maps/api)
import { GoogleMap, Circle, Marker } from "@react-google-maps/api";

// Google Maps Loader Helper
import { loadGoogleMaps, isGoogleMapsLoaded } from '../../helpers/googleMapsLoader';

// Map Theme
import { mapStyles } from '../../utils/mapTheme';

// UI Components
import ModernMapContainer from '../UI/ModernMapContainer';

// Assets
import mapPinIcon from '/public/SiteIcons/map_Pin.svg';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PlaceMap.css';
import cx from 'classnames';

//Image
import successIcon from '/public/SiteIcons/greatSuccess.svg';
import dangerIcon from '/public/SiteIcons/information-button.svg';

const containerStyle = {
  width: '100%',
  height: '100%'
};

class PlaceMap extends Component {
  static propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    isMapTouched: PropTypes.bool,
    onChange: PropTypes.any,
    change: PropTypes.any,
    mapSuccess: PropTypes.string,
    mapWarning: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      center: null,
      isMapTouched: false,
      markers: null,
      success: false,
      googleMapsLoaded: false
    }
    this.handleMarkerDragEnd = this.handleMarkerDragEnd.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { lat, lng, isMapTouched } = this.props;
    this.setState({
      center: {
        lat: Number(lat),
        lng: Number(lng),
      },
      isMapTouched: isMapTouched,
    });
  }

  async componentDidMount() {
    // Load Google Maps using official loader
    if (!isGoogleMapsLoaded()) {
      await loadGoogleMaps();
    }
    this.setState({ googleMapsLoaded: true });
  }

  geometryValue(value) {
    return value;
  }

  handleMarkerDragEnd(targetMarker) {
    const { isMapTouched } = this.state;
    const { onChange, change } = this.props;
    const center = {
      lat: targetMarker.latLng.lat(),
      lng: targetMarker.latLng.lng(),
      isMapTouched: true
    };
    this.setState({ center: center, isMapTouched: true });
    if (!isMapTouched) {
      this.setState({ success: true });
    }
    //onChange(this.geometryValue(center));
    change("ListPlaceStep1", "lat", center.lat);
    change("ListPlaceStep1", "lng", center.lng);
    change("ListPlaceStep1", "isMapTouched", center.isMapTouched);
  }

  renderWarning(message) {
    const { isMapTouched, success } = this.state;
    if (!isMapTouched) {
      return (
        <div className={cx(s.alertContainer, s.alertDanger)}>
          <img src={dangerIcon} className={cx(s.dangerIcon, 'dangerIconRTL')} />
          <span>{message}</span>
        </div>
      );
    }
    if (isMapTouched && success) {
      return (
        <div className={cx(s.alertContainer, s.alertSuccess)}>
          <img src={successIcon} className={cx(s.successIcon, 'dangerIconRTL')} />
          <span>{message}</span>
        </div>
      );
    }

  }

  handleOnLoad = (map) => {
    const { center } = this.state;
    const markers = [{
      position: new google.maps.LatLng(center.lat, center.lng)
    }];
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };

  render() {
    const { isMapTouched, center, googleMapsLoaded } = this.state;
    const { mapWarning, mapSuccess } = this.props;
    let message;

    if (!isMapTouched) {
      message = mapWarning;
    } else {
      message = mapSuccess;
    }

    return (
      <ModernMapContainer height="554px" mobileHeight="75vh" borderRadius="16px" mobileRadius="12px">
        {this.renderWarning(message)}
        {googleMapsLoaded && center && (
          <GoogleMap
            mapContainerStyle={containerStyle}
            onLoad={this.handleOnLoad}
            defaultZoom={14}
            center={center}
            options={{
              backgroundColor: '',
              scrollwheel: false,
              maxZoom: 16,
              minZoom: 11,
              streetViewControl: false,
              zoomControlOptions: {
                position: window.google?.maps?.ControlPosition?.LEFT_TOP || 5
              },
              mapTypeControl: false,
              styles: mapStyles
            }}
          >
            <Circle
              center={center}
              radius={212}
              options={{
                fillColor: '#090B1E1C',
                strokeColor: '#090B1E',
              }}
            />
            <Marker
              position={window.google?.maps ? new google.maps.LatLng(center.lat, center.lng) : center}
              draggable={true}
              onDragEnd={(event) => this.handleMarkerDragEnd(event)}
              icon={{
                url: mapPinIcon
              }}
            />
          </GoogleMap>
        )}
      </ModernMapContainer>
    );
  }
}

const mapState = (state) => ({
});

const mapDispatch = {
  change
};

export default withStyles(s)(connect(mapState, mapDispatch)(PlaceMap));
